<template>
    <v-card>
      <v-card-title>
        <v-row align="center" justify="center">
            <h3 class="primary--text font-weight-black text-uppercase">
              Términos y Condiciones
            </h3>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 200px;">
        <v-container fill-height>
          <v-layout>
            <v-row align="center" justify="center">
                <h3 class="text-justify primary--text font-italic font-weight-regular">
                  Al solicitar el factoraje electrónico o descuento electrónico del documento que selecciono e identifico, transmito los derechos que sobre el mismo ejerzo, de acuerdo con lo establecido por los artículos 427 de la ley general de títulos y operaciones de crédito, 32C del Código Fiscal de la Federación y 2038 del Código Civil Federal, haciéndome sabedor de su contenido y alcance, condicionado a que se efectúe el descuento electrónico o el factoraje electrónico. Todas las facturas proporcionadas mediante este medio están sujetas a validación.
                </h3>
            </v-row>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <v-row align="center" justify="center" class="my-2">
            <h3 class="text-center primary--text font-weight-black">¿Aceptas términos y condiciones?</h3>
        </v-row>
        <v-row align="center" justify="center">
              <!-- color="#5C9DF2" -->
            <v-btn
              large
              rounded
              color="#B0BEC5"
              @click="$emit('onClose', false)"
              class="font-weight-black mr-4">No</v-btn>
              <v-btn
              dark
              large
              rounded
              color="#5C9DF2"
              @click="$emit('onClose', true)"
              class="font-weight-black">Sí, acepto</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
</template>

<script>
export default {
  name: 'AuthorizeSelling',
  data () {
    return {}
  }
}
</script>

<style scoped>
</style>
